fx.service( class InstagramService extends fx.Service
{
    constructor(model)
    {
        super();

        this.model = model.creationModel;

        this.data = this.model.instagram;

        this._init();
    }

    /*
	*
    *  // ------------- EXTRACTOR -------------- //
    *
    */

	_init()
	{
		if (!this._instagramExtractor)
		{
			this._instagramExtractor = new shared.extractors.InstagramExtractor({data : this.model});
			this.on("photo-extracted", this._onInstagramPhotoExtracted, this._instagramExtractor);
		}
	}

    _onInstagramPhotoExtracted(e)
	{
		// send pictures to MediaUpoloader so they can be stored on server
		 fx.service("MediasUploader").upload(e.detail);
	}

    upload(selectedPhotos)
    {
		this._instagramExtractor.process(selectedPhotos);
    }

	addRawPhotos(datas)
	{
		let photos = [];
		for(let i = 0; i < datas.length; i++)
			photos.push(InstagramService.convertPhoto(datas[i]));

		this.upload(photos);
	}

    /*
    *
    *  // ------------- INSTAGRAM SDK -------------- //
    *
    */

	initSDK()
	{
		this._initInstagramSDK();
	}

	login(callback)
    {
		this._loginCallback = this._loginCallback.bind(this, callback);

		this._login();
    }

    getPhotos()
    {
        this._loadNextPhotos();
    }

    // -------------------- AUTH  --------------------- //

    _initInstagramSDK()
    {
        this._redirect_uri = fx.url('https://www.flexilivre.com/app/instagram');
		this._app_id = '657630184786012';
    }

	_getCookie()
	{
		let name = 'access_token';
		let matches = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	_login()
	{
		let url = `https://api.instagram.com/oauth/authorize/?client_id=${this._app_id}&redirect_uri=${ this._redirect_uri}&scope=user_profile,user_media&response_type=code`;

		window.instagramSDK.createPopup(url);
	}

	// --------------------- GET TOKEN  --------------------- //

	_setAuthCode(data)
	{
		let temporary_token = data.access_token;
		let client_secret = data.client_secret;

		this._changeToRefreshToken(client_secret, temporary_token);
	}
	
	_changeToRefreshToken(client_secret, temporary_token)
	{
		let requestOptions = {
			method: 'GET',
			redirect: 'follow',
		};

		let url = `https://graph.instagram.com/access_token?client_secret=${client_secret}&grant_type=ig_exchange_token&access_token=${temporary_token}`;

		fetch(url, requestOptions)
			.then(response => response.json())
			.then(result => {

				if (result.access_token)
				{
					// Set cookie with refresh access token
					document.cookie = `access_token=${result.access_token}; max-age=${result.expires_in}`;
					this._loginCallback();
				}
				else
					fx.log.error('Instagram : Something wrong. There is no token.');
			})
			.catch(error => {
				fx.log.error(error);
				this.data.event("instragram-error");
			});
	}

	_loginCallback(callback)
	{
		if (!this.data.length)
			this._getInstaData();

		callback();

		this.data.event("show-insta-photos");
	}

	// ---------------------- GET DATA  ---------------------- //

	_getInstaData()
	{
		let access_token = this._getCookie();

		let fields = 'id,media_type,media_url,caption,children,permalink,timestamp';
		let limit = 80;

		let url = `https://graph.instagram.com/me/media?fields=${fields}&access_token=${access_token}&limit=${limit}`;

		fetch(url)
			.then(response => response.json())
			.then(result => {

				this._addPhotos(result, access_token);
			})
			.catch(error => {
				fx.log.error(error);
				this.data.event("instragram-error");
			});
	}

	_addPhotos(result, access_token)
	{
		this.data.lazyLoadingActive = 0;

		if (result.paging.next)
			this.data.nextPhotos = result.paging.next;
		else
			this.data.nextPhotos = null;

		if (result.data.length && result.data.length > 0) {
			result.data.forEach(item => {
				if (item.media_type === 'IMAGE')
					this.data.addPhoto(InstagramService.convertPhoto(item));
				else if (item.media_type === 'CAROUSEL_ALBUM')
					this._getCarouselAlbumPhotos(item.children.data, access_token);
			});

			this.trigger("photos-loaded");
		}
	}

	_getCarouselAlbumPhotos(albumItems, access_token)
	{
		albumItems.forEach(item => {
			let fields = 'id,media_type,media_url,permalink,timestamp';

			let url = `https://graph.instagram.com/${item.id}?fields=${fields}&access_token=${access_token}`;

			fetch(url)
				.then(response => response.json())
				.then(item => {
					this.data.addPhoto(InstagramService.convertPhoto(item));
				})
				.catch(error => {
					fx.log.error(error);
					this.data.event("instragram-error");
				});
		});
	}

	static convertPhoto(rawPhoto)
	{
		let photo = {};

		photo.id = rawPhoto.id;
		photo.media_type = rawPhoto.media_type;
		photo.thumb = rawPhoto.media_url;
		photo.permalink = rawPhoto.permalink;
		photo.timestamp = rawPhoto.timestamp;

		return photo;
	}

	_loadNextPhotos()
	{
		let access_token = this._getCookie();

		fetch(this.data.nextPhotos)
			.then(response => response.json())
			.then(result => {

				this._addPhotos(result, access_token);
			})
			.catch(error => {
				fx.log.error(error);
				this.data.event("instragram-error");
			});
	}

});

window.instagramSDK = {

	// ---------------------- AUTH POPUP  --------------------- //

	createPopup(url)
	{
		this.closePopup();

		let tools =
			'status=no,resizable,toolbar=no,location=no,scrollbars=no,width=500,height=750,left=500,top=100';

		this.newWindow = window.open(url, 'InstaAuthWin', tools);

		if (!this.newWindow)
			alert('Veuillez autoriser les popups (ouverture de fenêtres) pour pouvoir continuer.');
		else this.newWindow.focus();
	},

	closePopup()
	{
		if (this.newWindow != null) {
			if (!this.newWindow.closed) this.newWindow.close();
		}
	},

	onStatusConnection(resp)
	{
		this.closePopup();

		window.fx.service("InstagramService")._setAuthCode(resp);
	},
};
